require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-five-things-veterans-need-to-know.json") })
        }
      }, "path---blog-five-things-veterans-need-to-know");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-five-things-veterans-need-to-know!./.cache/json/blog-five-things-veterans-need-to-know.json
// module id = 816
// module chunks = 231608221292675